import * as yup from "yup";
import { requiredMessage } from "../../../components/shared/form/formValidatonRules";

export const moveDocumentsSchema = yup.object().shape({
  FromAgency: yup.number().required(requiredMessage),
  ToAgency: yup.number().required(requiredMessage),
});
